module.exports = __webpack_public_path__ + "img/icon-ana-trivia.f13d1930.png";